import { AnyAction } from 'redux';

export const toolbarIsInteractiveReducer = function (
  sectionState: boolean = null,
  action: AnyAction,
): boolean {
  switch (action.type) {
    default:
      return sectionState;
  }
};
